/*
import HeaderTitle from './HeaderTitle';
import HeaderContainer from './HeaderContainer';
import { a11yProps } from 'pages/globals/global';
import { Box, Tab, Tabs, useMediaQuery } from '@mui/material';
import HeaderCreateButton from 'components/button/HeaderCreateButton';

const ComptrollerPageHeader = ({
	image,
	title,
	navigate,
	tabsItem,
	selectedTab,
	selectTabHandler,
	createBtn = true,
	scrollable = false,
	activeCreateButton,
}) => {
	const matchDownSM = useMediaQuery((theme) => theme.breakpoints.down('sm'));

	return (
		<HeaderContainer
			variant="comptroller"
			headerContent={
				<>
					<HeaderTitle alt="comptroller" image={image} title={title} />

					{createBtn && <HeaderCreateButton onCreateHandler={navigate} activeCreateButton={activeCreateButton} />}
				</>
			}
		>
			{tabsItem && (
				<Box sx={{ width: '100%', backgroundColor: 'white', borderRadius: '0px 0px 4px 4px' }}>
					<Tabs
						scrollButtons
						value={selectedTab}
						textColor="inherit"
						allowScrollButtonsMobile
						onChange={selectTabHandler}
						aria-label="basic tabs example"
						variant={scrollable ? 'scrollable' : matchDownSM ? 'scrollable' : 'standard'}
						sx={{
							minHeight: '42px',
							'& .MuiTabs-indicator': {
								backgroundColor: '#0052CC',
								borderRadius: '0px 0px 0px 4px',
							},
							'& .Mui-selected': {
								color: '#0052CC',
								fontWeight: '600',
							},
							'& .MuiTab-root': {
								backgroundColor: 'white',
								opacity: 1,
							},
						}}
					>
						{tabsItem?.map((item, index) => (
							<Tab
								key={item.label}
								label={item.label}
								iconPosition="start"
								sx={{
									fontSize: '14px',
									lineHeight: '18px',
									minHeight: '42px',
									padding: '12px 50px 12px 50px',
								}}
								{...a11yProps(index)}
							/>
						))}
					</Tabs>
				</Box>
			)}
		</HeaderContainer>
	);
};

export default ComptrollerPageHeader;
*/

import AddIcon from '@mui/icons-material/Add';
import { useState } from 'react';
import { Box, Button, Stack, Typography } from '@mui/material';

const AutoIcon = () => {
	return (
		<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M9 4h6l1 6-3 2v7l-2-2-2 2v-7l-3-2 1-6Z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
		</svg>
	);
};

const ComptrollerPageHeader = ({
	image,
	title,
	navigate,
	tabsItem,
	selectedTab,
	selectTabHandler,
	createBtn = true,
	activeCreateButton,
	onAuto = () => {},
}) => {
	const [isHeaderPinned, setIsHeaderPinned] = useState(false);

	const handleTabClick = (event, index) => {
		if (typeof selectTabHandler !== 'function') return;

		selectTabHandler(event, index);
	};

	const handleAutoClick = () => {
		const nextState = !isHeaderPinned;
		setIsHeaderPinned(nextState);
		onAuto(nextState);
	};

	return (
		<Box
			sx={{
				mb: '22px',
				position: isHeaderPinned ? 'sticky' : 'static',
				top: isHeaderPinned ? '60px' : 'auto',
				zIndex: isHeaderPinned ? 999 : 'auto',
				backgroundColor: isHeaderPinned ? 'background.main' : 'transparent',
			}}
		>
			<Box
				sx={{
					py: 1.75,
					borderRadius: '16px',
					px: { xs: 2, sm: 2.5 },
					backgroundColor: '#FFFFFF',
					border: '1px solid #E5E7EB',
					boxShadow: '0 1px 6px rgba(15, 23, 42, 0.05)',
				}}
			>
				<Stack direction={{ xs: 'column', lg: 'row' }} alignItems={{ xs: 'flex-start', lg: 'center' }} justifyContent="space-between" gap={1.5}>
					<Stack direction="row" alignItems="center" sx={{ gap: '10px' }}>
						<Typography sx={{ fontSize: '24px', lineHeight: 1.1, fontWeight: 600, color: '#1F2937' }}>{title}</Typography>
					</Stack>

					<Stack direction="row" alignItems="center" flexWrap="wrap" justifyContent={{ xs: 'flex-start', lg: 'flex-end' }} gap={1} width={{ xs: '100%', lg: 'auto' }}>
						<Box id="comptroller-page-search-slot" sx={{ minHeight: 36, display: 'flex', alignItems: 'center' }} />

						<Button
							onClick={handleAutoClick}
							startIcon={<AutoIcon />}
							sx={{
								px: 2,
								fontSize: '15px',
								fontWeight: 500,
								height: '36px',
								minHeight: '36px',
								borderRadius: '10px',
								textTransform: 'none',
								color: isHeaderPinned ? '#1D4ED8' : '#374151',
								border: `1px solid ${isHeaderPinned ? '#BFDBFE' : '#E5E7EB'}`,
								backgroundColor: isHeaderPinned ? '#EFF6FF' : '#FFFFFF',
							}}
						>
							Auto
						</Button>

						{tabsItem?.map((item, index) => {
							const isSelected = selectedTab === index;

							return (
								<Button
									key={`${item?.label}-${index}`}
									onClick={(event) => handleTabClick(event, index)}
									sx={{
										px: 2,
										fontSize: '15px',
										fontWeight: 500,
										height: '36px',
										minHeight: '36px',
										boxShadow: 'none',
										borderRadius: '10px',
										textTransform: 'none',
										color: isSelected ? '#FFFFFF' : '#475569',
										backgroundColor: isSelected ? '#0F172A' : 'transparent',
										'&:hover': {
											boxShadow: 'none',
											backgroundColor: isSelected ? '#0F172A' : '#F8FAFC',
										},
									}}
								>
									{item?.label}
								</Button>
							);
						})}

						<Box id="comptroller-page-columns-slot" sx={{ minHeight: 36, display: 'flex', alignItems: 'center' }} />

						{createBtn && (
							<Button
								onClick={navigate}
								disabled={activeCreateButton}
								startIcon={<AddIcon sx={{ fontSize: '18px' }} />}
								sx={{
									px: 2,
									fontSize: '15px',
									fontWeight: 500,
									color: '#FFFFFF',
									height: '36px',
									minHeight: '36px',
									borderRadius: '10px',
									textTransform: 'none',
									backgroundColor: '#1D4ED8',
									'&:hover': {
										backgroundColor: '#1E40AF',
									},
									'&.Mui-disabled': {
										color: '#E2E8F0',
										backgroundColor: '#93C5FD',
									},
								}}
							>
								Create
							</Button>
						)}
					</Stack>
				</Stack>
			</Box>
		</Box>
	);
};

export default ComptrollerPageHeader;
